export type Config = {
    configUrl: string;
    apiUrl: string;
    clientId: string;
};
